export const WO_TYPES = [{ value: "install", label: "Installation" }, { value: "service", label: "Service call" }, { value: "takedown", label: "Takedown" }];
export const DELAY_REASONS: Record<string, string> = { weather: "Weather", schedule_conflict: "Schedule conflict", materials: "Waiting on materials", other: "Other" };

export const WO_STATUS: Record<string, { label: string; cls: string }> = {
  scheduled: { label: "Scheduled", cls: "bg-blue-100 text-blue-800" },
  confirmed: { label: "Confirmed", cls: "bg-indigo-100 text-indigo-800" },
  en_route: { label: "En route", cls: "bg-amber-100 text-amber-800" },
  in_progress: { label: "In progress", cls: "bg-orange-100 text-orange-800" },
  completed: { label: "Completed", cls: "bg-green-100 text-green-800" },
  delayed: { label: "Delayed", cls: "bg-red-100 text-red-800" },
  cancelled: { label: "Cancelled", cls: "bg-gray-200 text-gray-700" },
};
export const fmtDate = (d?: string | null) => d ? new Date(d + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" }) : "Unscheduled";
export const StatusPill = ({ s }: { s: string }) => <span data-testid={`wo-status-pill-${s}`} className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${WO_STATUS[s]?.cls || "bg-gray-100"}`}>{WO_STATUS[s]?.label || s}</span>;

export function coverageIssues(u: any): string[] {
  const i = u?.installer || {};
  const out: string[] = [];
  const today = new Date(new Date().toDateString()).getTime();
  ([["wcb", "WCB"], ["insurance", "Insurance"]] as const).forEach(([k, label]) => {
    if (i[`${k}_covered_by_starlites`]) return;
    if (i[`${k}_review`]?.status === "rejected") out.push(`${label} certificate rejected`);
    else if (!i[k]) out.push(`No ${label} on file`);
    else if (i[`${k}_expiry`] && new Date(i[`${k}_expiry`] + "T00:00:00").getTime() < today) out.push(`${label} expired ${i[`${k}_expiry`]}`);
  });
  return out;
}

export const CoverageWarning = ({ u, compact }: { u: any; compact?: boolean }) => {
  const issues = coverageIssues(u);
  if (!issues.length) return null;
  return <span className="inline-flex items-center gap-1 rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-semibold text-red-800" title={issues.join(" · ")} data-testid={`coverage-warning-${u.id}`}>⚠ {compact ? "Coverage" : issues.join(" · ")}</span>;
};

export function warnCoverage(toastFn: (msg: string, opts?: any) => void, installers: any[], ids: string[]) {
  const bad = installers.filter((u) => ids.includes(u.id) && coverageIssues(u).length);
  if (bad.length) toastFn(`Coverage warning: ${bad.map((u) => `${u.name} — ${coverageIssues(u).join(", ")}`).join("; ")}`, { duration: 8000 });
}
